import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const InspectionPage = lazy(() => import('../pages/inspection/page'));
const ChinaCarsPage = lazy(() => import('../pages/china-cars/page'));
const USACarsPage = lazy(() => import('../pages/usa-cars/page'));
const EuropeCarsPage = lazy(() => import('../pages/europe-cars/page'));
const KoreaCarsPage = lazy(() => import('../pages/korea-cars/page'));
const UAECarsPage = lazy(() => import('../pages/uae-cars/page'));
const ElectricCarsPage = lazy(() => import('../pages/electric-cars/page'));
const PremiumCarsPage = lazy(() => import('../pages/premium-cars/page'));
const SUVCarsPage = lazy(() => import('../pages/suv-cars/page'));
const SportCarsPage = lazy(() => import('../pages/sport-cars/page'));
const FamilyCarsPage = lazy(() => import('../pages/family-cars/page'));
const BusinessCarsPage = lazy(() => import('../pages/business-cars/page'));
const AdExamplesPage = lazy(() => import('../pages/ad-examples/page'));
const BusinessCardPage = lazy(() => import('../pages/business-card/page'));
const ReviewsPage = lazy(() => import('../pages/reviews/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/inspection',
    element: <InspectionPage />,
  },
  {
    path: '/china-cars',
    element: <ChinaCarsPage />,
  },
  {
    path: '/usa-cars',
    element: <USACarsPage />,
  },
  {
    path: '/europe-cars',
    element: <EuropeCarsPage />,
  },
  {
    path: '/korea-cars',
    element: <KoreaCarsPage />,
  },
  {
    path: '/uae-cars',
    element: <UAECarsPage />,
  },
  {
    path: '/electric-cars',
    element: <ElectricCarsPage />,
  },
  {
    path: '/premium-cars',
    element: <PremiumCarsPage />,
  },
  {
    path: '/suv-cars',
    element: <SUVCarsPage />,
  },
  {
    path: '/sport-cars',
    element: <SportCarsPage />,
  },
  {
    path: '/family-cars',
    element: <FamilyCarsPage />,
  },
  {
    path: '/business-cars',
    element: <BusinessCarsPage />,
  },
  {
    path: '/ad-examples',
    element: <AdExamplesPage />,
  },
  {
    path: '/business-card',
    element: <BusinessCardPage />,
  },
  {
    path: '/reviews',
    element: <ReviewsPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
